import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent'; 
import dataModel from '../../models/DataModel';
import FileUtil from '../../helpers/FileUtil/FileUtil';

import './FileUploader.scss';

export default class FileUploader extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      file: '',
    };
  }

  handleFileSelect(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    if(file){
      // if(file.size > 25000000){
      //   console.log("ESTE ES EL LIMITE 23",)
      //   dataModel.displayWarnErrorMessage("File upload size limit is 25 MB. Please upload a smaller file", 4000, 2)
      // }
      // else {
      let fileExtension = FileUtil.getExtension(file.name);
      let acceptedType = this.handleDetermineMatchExt(fileExtension);
      if (acceptedType) {
        reader.onloadend = () => {
          this.setState({ file: file, imagePreviewUrl: reader.result, file_extension: fileExtension });
        };
        this
            .props
            .handleFileSelect(file, fileExtension, this.props.attachment, this.props.uploadSource);
      }
      else{
        dataModel.displayWarnErrorMessage(`Please upload a ${this.props.type.toUpperCase()} file.`, 4000, 2);
      }
      // }
    }
  }

  handleDetermineMatchExt(type){
    if(this.props.type){
      switch(this.props.type.toLowerCase()){
      case 'pdf':
        return type == this.props.type;
      case 'xlsx':
      case 'xls':
      case 'xlsm' :
        return type == 'xlsx' || type == 'xls' || type == 'xlsm';
      case 'docx':
      case 'doc':
        return type == 'docx' || type == 'doc' || type == 'rtf' || type == 'txt';
      case 'jpg':
      case 'jpeg':
      case 'png':
        return type == 'jpg' || type == 'jpeg' || type == 'png';
      case 'mp4':
        return type == 'mov' || type == 'mp4' || type == 'mp4v' || type == 'm4v' || type == '3gp';
      case 'other':
        return true;
      default:
        return true;
      }
    }
    return true;
  }

  render() {
    let {
      height,
      width,
      top,
      left,
      bottom,
      right,
      borderRadius,
      text,
      img,
      type,
      className,
    } = this.props;
    let style = !className ? {
      height: height,
      width: width,
      top: top,
      left: left,
      bottom: bottom,
      right: right,
      borderRadius: borderRadius,
    } : {};

    let imgDisplay = null;
    if (img) {
      imgDisplay = <img src={img} alt='Upload'/>;
    }

    let acceptedTypes = FileUtil.getAcceptedExtensionsByType(type);

    return (

      <div className={className ? className : 'file-uploader-img'} style={style}>
        <div className="file-img" onChange={(e) => this.handleFileSelect(e)}>
          {imgDisplay}
          <div className="file-text" style={{ lineHeight: height + 'px' }}>{text}</div>
          <input id='file-uploader' className="file-input" type="file" accept={acceptedTypes}/>
        </div>
      </div>
    );

  }
}



// WEBPACK FOOTER //
// ./src/components/FileUploader/index.js